<template>
  <div>
    <Breadcrumbs main="Турниры" title="Создать турнир"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h5>Создание турнира</h5><span></span>
            </div>
            <div class="card-body">
              <b-card>
                <!-- Выбор шаблона -->
              <div class="mb-3">
                <label class="font-weight-bold">Шаблон</label>
                <div class="d-flex">
                  <b-form-select
                      v-model="selectedTemplateId"
                      :options="templateOptions"
                      @change="applyTemplate"
                      :disabled="isTemplateLoading"
                  ></b-form-select>
                  <b-spinner v-if="isTemplateLoading" small variant="primary" class="ml-2 align-self-center"></b-spinner>
                </div>
                <small class="text-muted">Выберите шаблон для автозаполнения полей</small>
              </div>

              <b-tabs>
                  <ValidationObserver ref="form">
                    <b-tab title="Основные" active>
                      <template #title>
                        <span class="fa fa-home mr-2"></span>
                        <span>Основные</span>
                      </template>
                      <b-form>
                        <div class="mt-3">
                          <ValidationProvider>
                            <b-form-checkbox v-model="isHashTournament">Показывать только по ссылке</b-form-checkbox>
                          </ValidationProvider>
                        </div>
                        <div class="mt-3">
                          <ValidationProvider>
                            <b-form-checkbox v-model="withComments">Включить чат флудилку</b-form-checkbox>
                          </ValidationProvider>
                        </div>
                        <div class="mt-3">
                          <ValidationProvider>
                            <b-form-checkbox v-model="withCapChats">Включить кэп-чат</b-form-checkbox>
                          </ValidationProvider>
                        </div>
                        <b-tabs class="mt-3 d-flex justify-content-md-start justify-content-center flex-wrap">
                          <b-tab v-for="lang in languages"
                                 :title="lang.language"
                                 :key="'lang-' + lang.id"
                                 @click="getLanguageFromBtn(lang.language.toLowerCase())"
                                 nav-class="mr-2 mb-2">
                            <template #title>
                              <div class="d-flex justify-content-center">
                                <img :src="lang.img" width="20" height="20" class="mr-2">
                                <span>{{ lang.language }}</span>
                              </div>
                            </template>
                          </b-tab>
                        </b-tabs>
                        <div class="mt-3">
                          <label class="font-weight-bold star">Название турнира {{ language }}</label>
                          <ValidationProvider name="Название турнира" rules="min:2|required" v-slot="{errors}">
                            <b-form-input v-model="newTournamentName" type="text"
                                          placeholder="Название турнира" :state="!errors.length ? null : false"></b-form-input>
                            <div class="text-danger">{{ errors[0] }}</div>
                          </ValidationProvider>
                        </div>
                        <div style="margin-top: 10px;">
                          <label class="font-weight-bold star">Дисциплина</label>
                          <ValidationProvider rules="required" v-slot="{errors}">
                            <b-form-select :options="games" v-model="gameId"
                                           @change="handleGameChange" :state="!errors.length ? null : false"></b-form-select>
                            <div class="text-danger">{{ errors[0] }}</div>
                          </ValidationProvider>
                        </div>
                        <div class="mt-3">
                          <label class="font-weight-bold star">Тип турнира</label>
                          <ValidationProvider rules="required" v-slot="{errors}">
                            <b-form-select :options="variations" v-model="newVariation"></b-form-select>
                            <div class="text-danger">{{ errors[0] }}</div>
                          </ValidationProvider>
                        </div>
                        <div v-if="newVariation === 4" class="mt-3">
                          <label class="font-weight-bold star">Сезон BPL</label>
                          <ValidationProvider rules="required" v-slot="{ errors }">
                            <b-form-select :options="bplSeasons"
                                           v-model="bpl_season_id"
                                           :state="!errors.length ? null : false"></b-form-select>
                            <div class="text-danger">{{ errors[0] }}</div>
                          </ValidationProvider>
                        </div>
                        <div style="margin-top: 10px;">
                          <label class="font-weight-bold star">Организатор турнира</label>
                          <ValidationProvider rules="required" v-slot="{errors}">
                            <b-form-select :options="organizers" v-model="organizerId" :state="!errors.length ? null : false"></b-form-select>
                            <div class="text-danger">{{ errors[0] }}</div>
                          </ValidationProvider>
                        </div>
                        <div class="mt-3">
                          <label class="font-weight-bold star">Призовой фонд</label>
                          <ValidationProvider rules="required" v-slot="{errors}">
                            <b-form-input type="text" v-model="newPrizeFond" :state="!errors.length ? null : false"></b-form-input>
                            <div class="text-danger">{{ errors[0] }}</div>
                          </ValidationProvider>
                        </div>
                        <div>
                          <label class="font-weight-bold star">Кол-во команд</label>
                          <ValidationProvider rules="required" v-slot="{errors}">
                            <b-form-input type="number" v-model="newSlotCount" :state="!errors.length ? null : false"></b-form-input>
                            <div class="text-danger">{{ errors[0] }}</div>
                          </ValidationProvider>
                        </div>
                        <div class="mt-3">
                          <label class="font-weight-bold star">Формат</label>
                          <ValidationProvider rules="required" v-slot="{errors}">
                            <b-form-select :options="formats" v-model="newFormats" :state="!errors.length ? null : false"></b-form-select>
                            <div class="text-danger">{{ errors[0] }}</div>
                          </ValidationProvider>
                        </div>
                        <!--                    <div class="mt-3">-->
                        <!--                      <label class="font-weight-bold">Slug</label>-->
                        <!--                      <b-form-input v-model="newSlug"></b-form-input>-->
                        <!--                    </div>-->

                        <!--                    Был статус раньше, пока выпилили, мб пригодится-->
                        <!--                      <div class="mb-2">-->
                        <!--                        <label class="font-weight-bold"></label>-->
                        <!--                        <ValidationProvider rules="required" v-slot="{errors}">-->
                        <!--                          <b-form-select  v-model="newStatus" :options="newStatusOptions"></b-form-select>-->
                        <!--                          <div class="text-danger">{{errors[0]}}</div>-->
                        <!--                        </ValidationProvider>-->
                        <!--                      </div>-->
                        <div class="mb-2 mt-3">
                          <label class="font-weight-bold">Выбор страны</label>
                          <b-form-select v-model="newCountry" :options="countries"></b-form-select>
                        </div>
                        <div class="mt-3">
                          <label class="font-weight-bold star">Подача для Tier</label>
                          <ValidationProvider rules="required" v-slot="{ errors }">
                            <Multiselect :options="divisions" v-model="selectedDivision" label="text" track-by="value"
                                         :multiple="true" :hide-selected="true" :state="!errors.length ? null : false"></Multiselect>
                            <div class="text-danger">{{ errors[0] }}</div>
                          </ValidationProvider>
                        </div>
                        <div class="mt-3">
                          <label class="font-weight-bold">Ссылка трансляции</label>
                          <b-form-input type="text" v-model="newYoutubeLink"></b-form-input>
                        </div>
                        <div class="mt-3">
                          <label class="font-weight-bold">Серия турниров</label>
                          <b-form-input type="text" v-model="selectedTournamentSeries"></b-form-input>
                        </div>
                        <div class="mt-3">
                          <label class="font-weight-bold">Feature</label>
                          <Multiselect :options="featuresList" v-model="selectedFeature" label="text" track-by="value"
                                       :multiple="true" :hide-selected="true"></Multiselect>
                        </div>
                      </b-form>
                    </b-tab>

                    <b-tab title="Выбор времени">
                      <template #title>
                        <span class="fa fa-globe mr-2"></span>
                        <span>Выбор времени</span>
                      </template>
                      <b-form>
                        <div class="custom-control custom-checkbox pl-0">
                          <div class="mt-5">
                            <label for="" class="font-weight-bold">Часовой пояс <span class="text-danger">*</span></label>
                            <ValidationProvider rules="required" v-slot="{errors}">
                              <b-form-select format="YYYY-MM-DD H:i" :options="timezones"
                                             v-model="newTimezone" :state="!errors.length ? null : false"></b-form-select>
                              <div class="text-danger">{{ errors[0] }}</div>
                            </ValidationProvider>
                          </div>

                          <!-- Начало регистрации -->
                          <div>
                            <label for="" class="font-weight-bold">Начало регистрации <span class="text-danger">*</span></label>
                            <ValidationProvider rules="required" v-slot="{errors}">
                              <DatePicker
                                  ref="startRegPicker"
                                  mode="dateTime"
                                  v-model='newStartReg'
                                  is24hr
                                  :model-config="modelConfig"
                                  :popover="{
                                    visibility: 'click',
                                    placement: 'bottom-start',
                                    keepVisibleOnInput: true
                                  }"
                                  @popoverWillShow="handleCalendarOpen('startReg')"
                                  @popoverWillHide="handleCalendarClose"
                              >
                                <template v-slot="{inputValue, inputEvents}">
                                  <input
                                      type="text"
                                      class="form-control"
                                      :class="{ 'is-invalid': errors.length > 0 }"
                                      :value="inputValue"
                                      v-on="inputEvents"
                                      data-date-picker="startReg"
                                      readonly
                                  />
                                </template>
                              </DatePicker>
                              <div class="text-danger">{{ errors[0] }}</div>
                            </ValidationProvider>
                          </div>

                          <!-- Завершение регистрации -->
                          <div>
                            <label for="" class="font-weight-bold">Завершение регистрации <span class="text-danger">*</span></label>
                            <ValidationProvider rules="required" v-slot="{errors}">
                              <DatePicker
                                  ref="endRegPicker"
                                  mode="dateTime"
                                  v-model='newEndReg'
                                  is24hr
                                  :model-config="modelConfig"
                                  :popover="{
                                    visibility: 'click',
                                    placement: 'bottom-start',
                                    keepVisibleOnInput: true
                                  }"
                                  @popoverWillShow="handleCalendarOpen('endReg')"
                                  @popoverWillHide="handleCalendarClose"
                              >
                                <template v-slot="{inputValue, inputEvents}">
                                  <input
                                      type="text"
                                      class="form-control"
                                      :class="{ 'is-invalid': errors.length > 0 }"
                                      :value="inputValue"
                                      v-on="inputEvents"
                                      data-date-picker="endReg"
                                      readonly
                                  />
                                </template>
                              </DatePicker>
                              <div class="text-danger">{{ errors[0] }}</div>
                            </ValidationProvider>
                          </div>

                          <!-- Дата начала турнира -->
                          <div>
                            <label for="" class="font-weight-bold">Дата начала турнира <span class="text-danger">*</span></label>
                            <ValidationProvider rules="required" v-slot="{errors}">
                              <DatePicker
                                  ref="startTournamentPicker"
                                  mode="dateTime"
                                  v-model="newStartTournament"
                                  is24hr
                                  :model-config="modelConfig"
                                  :popover="{
                                    visibility: 'click',
                                    placement: 'bottom-start',
                                    keepVisibleOnInput: true
                                  }"
                                  @popoverWillShow="handleCalendarOpen('startTournament')"
                                  @popoverWillHide="handleCalendarClose"
                              >
                                <template v-slot="{inputValue, inputEvents}">
                                  <input
                                      type="text"
                                      class="form-control"
                                      :class="{ 'is-invalid': errors.length > 0 }"
                                      :value="inputValue"
                                      v-on="inputEvents"
                                      data-date-picker="startTournament"
                                      readonly
                                  />
                                </template>
                              </DatePicker>
                              <div class="text-danger">{{ errors[0] }}</div>
                            </ValidationProvider>
                          </div>
                        </div>
                      </b-form>
                    </b-tab>

                    <b-tab title="Описание">
                      <template #title>
                        <span class="fa fa-list-alt mr-2"></span>
                        <span>Описание</span>
                      </template>
                      <b-tabs class="mt-3 d-flex justify-content-md-start justify-content-center flex-wrap">
                        <b-tab v-for="lang in languages"
                               :title="lang.language"
                               :key="'lang-' + lang.id"
                               @click="getLanguageFromBtn(lang.language.toLowerCase())"
                               nav-class="mr-2 mb-2">
                          <template #title>
                            <div class="d-flex justify-content-center">
                              <img :src="lang.img" width="20" height="20" class="mr-2">
                              <span>{{ lang.language }}</span>
                            </div>
                          </template>
                        </b-tab>
                      </b-tabs>
                      <div class="mt-5">
                        <label for="" class="font-weight-bold star">Расписание {{ language.toUpperCase() }}</label>
                        <template v-for="lang in Object.keys(newSchedule)">
                          <ValidationProvider v-if="lang === 'ru'" rules="required" v-slot="{errors}">
                            <SunEditor :key="lang + '-schedule'"
                                       v-if="language === lang"
                                       v-model="newSchedule[lang]"
                                       :editorId="'schedule'"
                            />
                            <div class="text-danger">{{ errors[0] }}</div>
                          </ValidationProvider>
                          <div v-else>
                            <SunEditor :key="lang + '-schedule'"
                                       v-if="language === lang"
                                       v-model="newSchedule[lang]"
                                       :editorId="'schedule'"
                            />
                          </div>
                        </template>
                      </div>
                      <div class="mt-2">
                        <label class="font-weight-bold star">Описание {{ language.toUpperCase() }}</label>
                        <template v-for="lang in Object.keys(newDescription)">
                          <ValidationProvider v-if="lang === 'ru'" rules="required" v-slot="{errors}">
                            <SunEditor :key="lang + '-description'"
                                       v-if="language === lang"
                                       v-model="newDescription[lang]"
                                       :editorId="'description'"
                            />
                            <div class="text-danger">{{ errors[0] }}</div>
                          </ValidationProvider>
                          <div v-else>
                            <SunEditor :key="lang + '-description'"
                                       v-if="language === lang"
                                       v-model="newDescription[lang]"
                                       :editorId="'description'"
                            />
                          </div>
                        </template>
                      </div>
                      <div class="mt-2">
                        <label class="font-weight-bold star">Правила {{ language.toUpperCase() }}</label>
                        <template v-for="lang in Object.keys(newRules)">
                          <ValidationProvider v-if="lang === 'ru'" rules="required" v-slot="{errors}">
                            <SunEditor :key="lang + '-rules'"
                                       v-if="language === lang"
                                       v-model="newRules[lang]"
                                       :editorId="'rules'"
                            />
                            <div class="text-danger">{{ errors[0] }}</div>
                          </ValidationProvider>
                          <div v-else>
                            <SunEditor :key="lang + '-rules'"
                                       v-if="language === lang"
                                       v-model="newRules[lang]"
                                       :editorId="'rules'"
                            />
                          </div>
                        </template>
                      </div>

                      <div class="mt-2 font-weight-bold">
                        <label>Выбрать обложку</label>
                        <b-form-file v-model="newImage" @change="showImage($event)" class="mb-3"></b-form-file>
                        <img id="outputCreate" class="w-100">
                      </div>
                      <div class="mt-2 font-weight-bold">
                        <label>Выбрать мобильную обложку</label>
                        <b-form-file v-model="newMobileImage" @change="showMobileImage($event)" class="mb-3"></b-form-file>
                        <img id="outputCreate2" class="w-100">
                      </div>
                    </b-tab>
                    <b-tab title="Place pts">
                      <template #title>
                        <span class="fa fa-database mr-2"></span>
                        <span>Очки за place</span>
                      </template>
                      <AddTournamentPlace></AddTournamentPlace>
                    </b-tab>
                    <b-tab title="Place pts">
                      <template #title>
                        <span class="fa fa-database mr-2"></span>
                        <span>Призы за place</span>
                      </template>
                      <AddTournamentPrize />
                    </b-tab>
                    <b-tab title="Мета данные">
                      <template #title>
                        <span class="fa fa-database mr-2"></span>
                        <span>Мета данные</span>
                      </template>
                      <div>
                        <b-tabs class="mt-3 d-flex justify-content-md-start justify-content-center flex-wrap">
                          <b-tab v-for="lang in languages"
                                 :title="lang.language"
                                 :key="'lang-' + lang.id"
                                 @click="getLanguageFromBtn(lang.language.toLowerCase())"
                                 nav-class="mr-2 mb-2">
                            <template #title>
                              <div class="d-flex justify-content-center">
                                <img :src="lang.img" width="20" height="20" class="mr-2">
                                <span>{{ lang.language }}</span>
                              </div>
                            </template>
                          </b-tab>
                        </b-tabs>

                        <div class="mt-5">
                          <div>
                            <label class="font-weight-bold">Мета заголовок {{ language }}</label>
                            <b-form-input v-model="newMetaTitle[language]" placeholder="Название"></b-form-input>
                          </div>
                          <div class="mt-2">
                            <label class="font-weight-bold">Мета описание {{ language }}</label>
                            <b-textarea v-model="newMetaDescription[language]" class="h-30"></b-textarea>
                          </div>
                        </div>
                      </div>
                    </b-tab>
                  </ValidationObserver>
                </b-tabs>

                <div class="mt-3 justify-content-center align-items-center">
                  <button @click="createTournament()" type="button" class="btn btn-success">Сохранить</button>
                  <div>{{ errorMessage }}</div>
                </div>
              </b-card>

            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
import { DatePicker } from 'v-calendar';
import {TournamentAdapterMixin} from "../../mixins/Tournament/TournamentAdapterMixin";
import {LanguageAdapterMixin} from "../../mixins/Language/LanguageAdapterMixin";
import Multiselect from "vue-multiselect";
import {FeaturesAdapterMixin} from "@/mixins/Features/FeaturesAdapterMixin";
import {DivisionsAdapterMixin} from "@/mixins/Divisions/DivisionsAdapterMixin";
import AddTournamentPlace from "@/pages/Tournament/AddTournamentPlace.vue";
import AddTournamentPrize from './AddTournamentPrize.vue';
import SunEditor from "@/components/SunEditor.vue";
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import api from "@/api/api";

export default {
  name: 'CreateTournament',
  mixins: [TournamentAdapterMixin, LanguageAdapterMixin, FeaturesAdapterMixin, DivisionsAdapterMixin],
  components: {SunEditor, DatePicker, Multiselect, AddTournamentPlace, AddTournamentPrize, ValidationObserver, ValidationProvider},
  data() {
    return {
      modelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD HH:mm',
      },
      activeCalendar: null,
      striped: true,
      bordered: true,
      invalid: null,
      selectedDivision: [],
      selectedTemplateId: null,
      templateOptions: [{ value: null, text: '— Без шаблона —' }],
      isTemplateLoading: false,
    }
  },
  async mounted() {
    await Promise.allSettled([
      this.grabGames(),
      this.grabOrganizers(),
      this.indexTimeZones(),
      this.getCountriesQuery(),
      this.grabFeaturesList(),
      this.grabVariations(),
      this.grabBplSeasons(),
      this.loadTemplateOptions(),
    ])

    // Автоприменение шаблона из query-параметра (?template_id=X)
    const templateId = Number(this.$route.query.template_id)
    if (templateId) {
      this.selectedTemplateId = templateId
      await this.applyTemplate(templateId)
    }

    // Улучшенный глобальный обработчик для закрытия календарей
    this.setupGlobalClickHandler();
  },
  methods: {
    showImage(event) {
      let output = document.getElementById('outputCreate')
      output.src = URL.createObjectURL(event.target.files[0])
      output.onload = function () {
        URL.revokeObjectURL(output.src)
      }
    },
    showMobileImage(event) {
      let output = document.getElementById('outputCreate2')
      output.src = URL.createObjectURL(event.target.files[0])
      output.onload = function () {
        URL.revokeObjectURL(output.src)
      }
    },
    async loadTemplateOptions() {
      try {
        const res = await api.tournamentTemplate.index({ per_page: 100 })
        // Поддержка обоих форматов: { data: [...] } и просто [...]
        const templates = Array.isArray(res.data?.data) ? res.data.data
            : Array.isArray(res.data) ? res.data
            : []
        this.templateOptions = [
          { value: null, text: '— Без шаблона —' },
          ...templates.map(t => ({ value: t.id, text: t.name }))
        ]
      } catch (e) {
        console.error('Failed to load templates', e)
      }
    },

    async applyTemplate(templateId) {
      if (!templateId) return
      this.isTemplateLoading = true
      try {
        const res = await api.tournamentTemplate.show(templateId)
        // Поддержка обоих форматов: { data: { id, name, data } } и { id, name, data }
        const responseData = res.data
        const tpl = responseData?.data?.id !== undefined ? responseData.data : responseData
        const rawData = tpl?.data
        if (!rawData) return
        const d = typeof rawData === 'string' ? JSON.parse(rawData) : rawData

        // Скалярные поля
        if (d.name) this.newTournamentName = d.name
        if (d.game_id) {
          this.gameId = d.game_id
          await this.getFormatsByGameId()
        }
        if (d.variation_id !== undefined) this.newVariation = d.variation_id
        if (d.bpl_season_id !== undefined) this.bpl_season_id = d.bpl_season_id
        if (d.organizer_id) this.organizerId = d.organizer_id
        if (d.prize_fond) this.newPrizeFond = d.prize_fond
        if (d.slot_count) this.newSlotCount = d.slot_count
        if (d.format_id) this.newFormats = d.format_id
        if (d.country_id) this.newCountry = d.country_id
        if (d.youtube_link) this.newYoutubeLink = d.youtube_link
        if (d.timezone) this.newTimezone = d.timezone
        if (d.hash !== undefined) this.isHashTournament = d.hash
        if (d.with_comments !== undefined) this.withComments = d.with_comments
        if (d.with_cap_chats !== undefined) this.withCapChats = d.with_cap_chats
        if (d.start_reg_time) this.newStartReg = d.start_reg_time
        if (d.end_reg_time) this.newEndReg = d.end_reg_time
        if (d.start_time) this.newStartTournament = d.start_time

        // Серия турниров (related_tournament_ids → строка через запятую)
        if (d.related_tournament_ids && d.related_tournament_ids.length) {
          this.selectedTournamentSeries = d.related_tournament_ids.join(', ')
        }

        // Языковые объекты
        if (d.description) this.newDescription = { ...this.newDescription, ...d.description }
        if (d.schedule) this.newSchedule = { ...this.newSchedule, ...d.schedule }
        if (d.rules) this.newRules = { ...this.newRules, ...d.rules }
        if (d.meta_title) this.newMetaTitle = { ...this.newMetaTitle, ...d.meta_title }
        if (d.meta_description) this.newMetaDescription = { ...this.newMetaDescription, ...d.meta_description }

        // Features
        if (d.features_ids && this.featuresList) {
          this.selectedFeature = this.featuresList.filter(f => d.features_ids.includes(f.value))
        }

        // Divisions (опции загружены через getFormatsByGameId выше)
        if (d.divisions && this.divisions) {
          this.selectedDivision = this.divisions.filter(div => d.divisions.includes(div.value))
        }

        // Place points — добавляем id для корректной работы Vuex-стора
        if (d.tournament_place_points) {
          try {
            const pts = typeof d.tournament_place_points === 'string'
                ? JSON.parse(d.tournament_place_points)
                : d.tournament_place_points
            this.tournamentPlaces = pts.map((item, index) => ({
              id: index + 1,
              place: item.place,
              place_pts: item.place_pts,
            }))
          } catch (e) { /* ignore */ }
        }

        // Prize fund — добавляем id для корректной работы Vuex-стора
        if (d.prize_fund && d.prize_fund.length) {
          this.tournamentPrizes = d.prize_fund.map((item, index) => ({
            id: index + 1,
            place: item.place,
            prize_data: item.prize_data || { amount: 0 },
          }))
        }

        const t = this.$toasted.success('Шаблон применён', {
          action: {
            text: '✕',
            onClick: (e, toastObject) => { toastObject.goAway(0) }
          }
        })
        setTimeout(() => { if (t) t.goAway(0) }, 3000)
      } catch (e) {
        const te = this.$toasted.error('Не удалось загрузить шаблон', {
          action: { text: '✕', onClick: (e, o) => { o.goAway(0) } }
        })
        setTimeout(() => { if (te) te.goAway(0) }, 3000)
        console.error(e)
      } finally {
        this.isTemplateLoading = false
      }
    },

    handleGameChange() {
      this.selectedDivision = [];
      this.getFormatsByGameId();
    },

    /**
     * Настройка глобального обработчика кликов - более безопасная версия
     */
    setupGlobalClickHandler() {
      this.globalClickHandler = (event) => {
        // Проверяем что клик не внутри календаря
        const isInsideCalendar = event.target.closest('.vc-container') ||
            event.target.closest('.vc-popover-content-wrapper') ||
            event.target.closest('[data-date-picker]') ||
            event.target.closest('.vc-popover-trigger');

        if (!isInsideCalendar && this.activeCalendar) {
          // Добавляем небольшую задержку для избежания конфликтов
          setTimeout(() => {
            this.activeCalendar = null;
          }, 50);
        }
      };

      document.addEventListener('click', this.globalClickHandler, { capture: false });
    },

    /**
     * Обработчик открытия календаря - упрощенная версия
     */
    handleCalendarOpen(calendarName) {
      // Закрываем другие календари перед открытием нового
      this.closeOtherCalendars(calendarName);
      this.activeCalendar = calendarName;
    },

    /**
     * Обработчик закрытия календаря
     */
    handleCalendarClose() {
      this.activeCalendar = null;
    },

    /**
     * Закрытие других календарей - безопасная версия с использованием ref'ов
     */
    closeOtherCalendars(currentCalendar) {
      const calendars = {
        startReg: 'startRegPicker',
        endReg: 'endRegPicker',
        startTournament: 'startTournamentPicker'
      };

      Object.keys(calendars).forEach(calendarKey => {
        if (calendarKey !== currentCalendar) {
          const pickerRef = calendars[calendarKey];
          if (this.$refs[pickerRef] && this.$refs[pickerRef].hidePopover) {
            try {
              this.$refs[pickerRef].hidePopover();
            } catch (error) {
              // Игнорируем ошибки при закрытии календарей
              console.warn('Не удалось закрыть календарь:', pickerRef);
            }
          }
        }
      });
    },

    /**
     * Альтернативный метод для принудительного закрытия всех календарей
     * Используется в экстренных случаях
     */
    closeAllCalendars() {
      const pickers = ['startRegPicker', 'endRegPicker', 'startTournamentPicker'];

      pickers.forEach(pickerRef => {
        if (this.$refs[pickerRef] && this.$refs[pickerRef].hidePopover) {
          try {
            this.$refs[pickerRef].hidePopover();
          } catch (error) {
            console.warn('Не удалось закрыть календарь:', pickerRef);
          }
        }
      });

      this.activeCalendar = null;
    }
  },
  destroyed() {
    this.gameId = null;
  },

  beforeDestroy() {
    // Убираем обработчик при уничтожении компонента
    if (this.globalClickHandler) {
      document.removeEventListener('click', this.globalClickHandler);
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
@import "~@/assets/scss/star.scss";

// Дополнительные стили для календарей
.vc-container {
  position: relative;
  z-index: 1050; // Убеждаемся что календарь поверх других элементов
}

// Стили для улучшения UX календарей
[data-date-picker] {
  cursor: pointer;
}

// Предотвращаем выделение текста в readonly input'ах
[data-date-picker][readonly] {
  background-color: #fff;
  opacity: 1;
  user-select: none;
}
</style>